import axios from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import usersApi from 'api/rest/users/users';
import type { Me } from 'api/rest/users/users.types';
import QUERY from 'constants/queryKeys';

const shouldRetryMeQuery = (failureCount: number, error: unknown): boolean => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      return false;
    }
  }
  return failureCount < 3;
};

/** Shared GET /users/me/ options — one fetch until invalidated; never on window focus. */
export const ME_QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false as const,
  refetchOnReconnect: false as const,
  retry: shouldRetryMeQuery,
};

type MeQueryOptions = Omit<UseQueryOptions<Me | null, unknown, Me | null, string>, 'queryKey' | 'queryFn'>;

const useMeQuery = (options?: MeQueryOptions): UseQueryResult<Me | null> =>
  useQuery(QUERY.GET_ME, usersApi.getMe(), {
    ...ME_QUERY_OPTIONS,
    ...options,
  });

export default useMeQuery;
